<template>
  <div class="c-blockquote-blue-box">
    <sc-text
      tag="h3"
      class="c-blockquote-blue-box__headline"
      v-if="fields && fields.heading"
      :field="fields.heading"
    />
    <div class="c-blockquote-blue-box__quote">
      <sc-text class="quote" v-if="fields && fields.quote" :field="fields.quote" />
      <sc-rich-text class="quote" v-if="fields && fields.quoteRte" :field="fields.quoteRte" />
      <sc-text class="name" v-if="fields && fields.name" :field="fields.name" />
      <sc-text class="title" v-if="fields && fields.title" :field="fields.title" />
    </div>
  </div>
</template>

<script>
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Blockquote-Blue-Box',
  components: {
    ScText: Text,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-blockquote-blue-box {
  margin: 4rem 0;
  padding: 2rem 2rem 3rem 2rem;
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );
  border-radius: 0.5rem;

  @include desktop-up {
    margin: 5rem 0;
    padding: 4rem;
  }

  &__headline {
    @include font-styles('Arial', 2rem, 100, normal, 2.6rem, 0, $white);
    margin-bottom: 2rem;

    @include desktop-up {
      font-size: 2.8rem;
      line-height: 3.5rem;
      margin-bottom: 3rem;
    }
  }

  &__quote {
    position: relative;
    padding-left: 4.5rem;

    @include tablet-up {
      padding-left: 7rem;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 3rem;
      height: 3rem;
      background-image: url(~@/assets/images/icon-quotes-white.svg);
      background-repeat: no-repeat;
      background-size: contain;

      @include tablet-up {
        width: 5rem;
        height: 5rem;
      }
    }

    .quote {
      display: block;
      @include font-styles('Arial', 1.8rem, 100, italic, 2.4rem, 0, $white);
      margin-bottom: 1.6rem;

      @include desktop-up {
        font-size: 2.3rem;
        line-height: 3.5rem;
        margin-bottom: 2rem;
      }

      &:deep() {
        p,
        span,
        a {
          @include font-styles('Arial', 1.8rem, 100, italic, 2.4rem, 0, $white);
          @include desktop-up {
            font-size: 2.3rem;
            line-height: 3.5rem;
          }
        }

        a {
          font-weight: 200;
        }
      }
    }

    .name {
      display: block;
      @include font-styles('Arial', 1.6rem, 500, normal, 2rem, 0, $white);

      @include desktop-up {
        font-size: 1.8rem;
        line-height: 3.5rem;
      }
    }

    .title {
      display: block;
      @include font-styles('Arial', 1.6rem, 200, normal, 2rem, 0, $white);

      @include desktop-up {
        font-size: 1.8rem;
        line-height: 2.2rem;
      }
    }
  }
}
</style>
